export interface SelectOption {
  value: any;
  label: string;
}

// Tipi di azienda
export const companyTypes: SelectOption[] = [
  { value: "company", label: "Company" },
  { value: "institution", label: "Institution" },
  { value: "university", label: "University" },
  { value: "newspaper", label: "Newspaper" },
  { value: "freelancer", label: "Freelance" },
];

// Ordini professionali di appartenenza
export const membershipGroupTypes: SelectOption[] = [
  { value: "geologists", label: "Geologi" },
  { value: "engineers", label: "Ingegneri" },
  { value: "surveyors", label: "Geometri" },
  { value: "agronomists_forest", label: "Agronomi / Forestali" },
  { value: "architects", label: "Architetti" },
  { value: "lawyers", label: "Avvocati" },
  { value: "journalists", label: "Giornalisti" },
  { value: "chemist_physicist", label: "Chimici / Fisici" },
];

// Segmenti remtech
// TODO: step 2 modularize this
export const remtechSegments: SelectOption[] = [
  { value: "remtech_europe", label: "RemTech Europe" },
  { value: "remtech", label: "RemTech" },
  { value: "coast", label: "Coast" },
  { value: "inertia", label: "Inertia" },
  { value: "geosismica", label: "Geosismica" },
  { value: "esonda", label: "Esonda" },
  { value: "rigenera_city", label: "RigeneraCity" },
  { value: "clime_tech", label: "ClimeTech" },
  { value: "chem_tech", label: "ChemTech" },
  { value: "restauro_tech", label: "RestauroTech" },
];
